import React from 'react';
import './CurriculumBadge.css';

export function CurriculumBadge({ label, inactive = false }: { label?: string; inactive?: boolean }) {
  const subject = (label || '').replace(/[_-]+/g, ' ').toLowerCase();
  const curriculum = /movie|film/.test(subject) ? ['Movie Making', '94.265233% 3.484321%']
    : /entrepreneur|business/.test(subject) ? ['Entrepreneurship', '50% 3.484321%']
    : /music/.test(subject) ? ['Music', '94.265233% 83.623693%']
    : /game|gaming/.test(subject) ? ['Game Design', '5.734767% 83.623693%']
    : /app|software/.test(subject) ? ['App Development', '50% 83.623693%']
    : /\bai\b|artificial intelligence/.test(subject) ? ['Intro to AI', '5.734767% 3.484321%'] : null;
  const name = curriculum?.[0] || 'Curriculum not listed';
  return <span className="universe-curriculum-badge" data-curriculum-badge tabIndex={inactive ? -1 : 0} aria-label={`Curriculum: ${name}`}>
    {curriculum ? <span className="universe-curriculum-badge__art" style={{ backgroundPosition: curriculum[1] }} aria-hidden="true" /> : <span className="universe-curriculum-badge__fallback" aria-hidden="true">✦</span>}
    <span className="universe-curriculum-badge__label" role="tooltip">{name}</span>
  </span>;
}
